"use client";

import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../hooks/useAuth";
import { getUserTypeColor } from "../../../utils/userTypeUtils";
import "./ConfirmModal.css";

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  showWarningIcon = false,
}) => {
  const { t, i18n } = useTranslation();
  const { getUserType } = useAuth();
  const currentUserType = getUserType();
  const userTypeColor = getUserTypeColor(currentUserType);

  if (!isOpen) return null;

  const handleCancel = () => {
    if (onCancel) onCancel();
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
  };

  const modal = (
    <div
      className="confirm-modal-overlay"
      onClick={handleCancel}
      dir={i18n.language?.startsWith("ar") ? "rtl" : "ltr"}
    >
      <div
        className="confirm-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ "--user-type-color": userTypeColor }}
      >
        {showWarningIcon && (
          <div className="confirm-modal-icon">
            <div className="confirm-modal-icon-circle">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 8V12M12 16H12.01M10.29 2.86L1.82 18C1.64538 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7238C2.83871 20.9009 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.9009 21.4623 20.7238C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 2.86C13.5325 2.56611 13.2805 2.32311 12.9811 2.15447C12.6817 1.98584 12.3438 1.89725 12 1.89725C11.6562 1.89725 11.3183 1.98584 11.0189 2.15447C10.7195 2.32311 10.4675 2.56611 10.29 2.86Z"
                  stroke="#EF4444"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        )}
        <div className="confirm-modal-content">
          <h2 className="confirm-modal-title">
            {title ||
              t("common.confirmTitle", "Please confirm")}
          </h2>
          <div className="confirm-modal-body">
            <p>{message}</p>
          </div>
          <div className="confirm-modal-actions">
            <button
              type="button"
              className="confirm-modal-cancel"
              onClick={handleCancel}
            >
              {cancelLabel || t("common.cancel", "Cancel")}
            </button>
            <button
              type="button"
              className="confirm-modal-confirm"
              onClick={handleConfirm}
            >
              {confirmLabel || t("common.confirm", "OK")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default ConfirmModal;


